module.exports = __webpack_public_path__ + "img/wb_logo.db40ea91.png";